import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  Input,
  QueryList,
} from '@angular/core';
import { BllTableColumnDirective } from './table-row.directive';

@Component({
  selector: 'bll-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BllTableComponent {
  @Input()
  set data(value: any) {
    this.originalData = value;
    this.displayData = value;
  }
  displayData: any[];
  private originalData: any[];
  @ContentChildren(BllTableColumnDirective, { descendants: true, emitDistinctChangesOnly: true })
  columns: QueryList<BllTableColumnDirective>;

  constructor(private _changeDetectorRef: ChangeDetectorRef) {}

  // ngAfterViewInit() {
  //   this.columns.changes.subscribe(this.recalcWidth);
  //   this.recalcWidth(this.columns);
  // }

  // recalcWidth = (columns: QueryList<BllTableColumnDirective>) => {
  //   this.columns.forEach((column: BllTableColumnDirective) => {
  //     if (!column.width) {
  //       console.log(column);
  //     }
  //   });
  // };

  sortDesc = true;
  sortBy = null;
  sort(column, index) {
    if (!column.sortable) {
      return;
    }
    this.columns.forEach((col) => {
      if (col !== column) {
        col.sorted = null;
      }
    });
    column.sorted = column.sorted === null ? 'asc' : column.sorted === 'asc' ? 'desc' : null;
    this.sortDesc = column.sorted === 'desc';

    const data = [...this.originalData];
    if (column.sorted === null) {
      this.displayData = data;
      this.sortBy = null;
    } else {
      this.sortBy = column.header;
      this.displayData = data.sort((a, b) => {
        if (column.sorted === 'desc') {
          return a[index] > b[index] ? 1 : -1;
        }
        return a[index] < b[index] ? 1 : -1;
      });
    }
    this._changeDetectorRef.markForCheck();
  }
}
